import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  Acceptance_Bool_Exp,
  GetAcceptanceCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAcceptanceCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type AcceptanceCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Acceptance_Bool_Exp;
};

export const useGetAcceptanceCount = createQueryHook<
  AcceptanceCountArgs,
  NavigationCounts,
  GetAcceptanceCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    acceptance_aggregate: { aggregate: toAggregate(data.acceptance) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAcceptanceCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
